import YellowButtonImage from "../images/cardImages/yellow_button.png";

export const cards = [
  {
    username: "Masterbrian99",
    image: YellowButtonImage,
    path: "/yellow-button",
    itemName: "Yellow Button",
  },
];
